import { Box, BoxProps } from '@mui/material';
import React from 'react';

import { Typography } from '../Typography/Typography';

export type MenuLinkProps = BoxProps & {
  startIcon?: null | React.ReactNode;
  endIcon?: null | React.ReactNode;
  underlined?: boolean;
};

export const MenuLink: React.FC<MenuLinkProps> = ({
  children,
  startIcon,
  endIcon,
  underlined,
  ...props
}: MenuLinkProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={{ xs: 4, md: 5 }}
      py={{ xs: 5, md: 4 }}
      px={{ xs: 5, md: 6 }}
      minHeight={{ xs: '18px', lg: '24px' }}
      {...props}
      sx={{
        '&:hover .MuiTypography-button': {
          borderBottomColor: 'grey.main',
        },
      }}
    >
      <Box display="flex" flexGrow={1} gap={{ xs: 4, lg: 5 }}>
        {startIcon && (
          <Box display="inline-flex" sx={{ fontSize: { xs: '18px', lg: '24px' } }}>
            {startIcon}
          </Box>
        )}
        <Typography
          variant="button"
          fontWeight={{ xs: 'bold', md: '400' }}
          borderBottom={1}
          borderColor="transparent"
          sx={{
            textDecoration: underlined ? 'underline' : 'none',
            color: { md: 'grey.main' },
          }}
        >
          {children}
        </Typography>
      </Box>
      {endIcon && (
        <Box display="inline-flex" sx={{ fontSize: { xs: '18px', lg: '24px' } }}>
          {endIcon}
        </Box>
      )}
    </Box>
  );
};
